import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "name", "label", "isRequired", "validators", "validationHelpText", "testId"],
  _excluded2 = ["fieldId", "isRequired"],
  _excluded3 = ["children"],
  _excluded4 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { Inline } from '@atlaskit/primitives';
import AkSelect, { components } from '@atlaskit/select';
import { layers } from '@atlaskit/theme/constants';
import { UrlIcon } from '../../../common/ui/icon';
import { CreateField } from '../../../controllers/create-field';
import { messages } from './messages';
export var TEST_ID = 'link-create-select';

/**
 * A select component utilising the Atlaskit Select and CreateField.
 * Validation is handled by the form on form submission. Any
 * errors returned by the handleSubmit function passed to the form <Form> that
 * have a key matching the `name` of this field are shown below the field.
 */
export function Select(_ref) {
  var id = _ref.id,
    name = _ref.name,
    label = _ref.label,
    isRequired = _ref.isRequired,
    validators = _ref.validators,
    validationHelpText = _ref.validationHelpText,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? TEST_ID : _ref$testId,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return jsx(CreateField, {
    id: id,
    name: name,
    label: label,
    isRequired: isRequired,
    validators: validators,
    validationHelpText: validationHelpText,
    testId: testId
  }, function (_ref2) {
    var fieldId = _ref2.fieldId,
      isRequired = _ref2.isRequired,
      fieldProps = _objectWithoutProperties(_ref2, _excluded2);
    return jsx(AkSelect, _extends({
      required: isRequired,
      inputId: fieldId
    }, fieldProps, restProps));
  });
}
export var SiteSelect = function SiteSelect(_ref3) {
  var options = _ref3.options,
    name = _ref3.name,
    testId = _ref3.testId;
  var intl = useIntl();
  var siteTestId = testId ? testId : 'link-create-site-picker';
  return jsx(Select, {
    isRequired: true,
    isSearchable: true,
    name: name !== null && name !== void 0 ? name : 'site',
    options: options,
    label: intl.formatMessage(messages.siteLabel),
    components: {
      Option: SitePickerOption,
      SingleValue: SitePickerSingleValue
    },
    testId: siteTestId,
    styles: {
      menuPortal: function menuPortal(base) {
        return _objectSpread(_objectSpread({}, base), {}, {
          zIndex: layers.modal()
        });
      },
      option: function option(base) {
        return _objectSpread(_objectSpread({}, base), {}, {
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer'
        });
      }
    }
  });
};
var SiteRow = function SiteRow(_ref4) {
  var avatarUrl = _ref4.avatarUrl,
    children = _ref4.children;
  return jsx(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, avatarUrl ? jsx(UrlIcon, {
    url: avatarUrl
  }) : null, children);
};
export var SitePickerOption = function SitePickerOption(_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded3);
  return jsx(components.Option, props, jsx(SiteRow, {
    avatarUrl: props.data.value.avatarUrl
  }, children));
};
export var SitePickerSingleValue = function SitePickerSingleValue(_ref6) {
  var children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded4);
  return jsx(components.SingleValue, props, jsx(SiteRow, {
    avatarUrl: props.data.value.avatarUrl
  }, children));
};